import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'
import { getUserInfo } from '@/utils/api'
import type { GameGlassUser } from '@/types/api'

// TODO: aggregate all queries together
export const CURRENT_USER_QUERY_KEY = 'currentUser' as const

export type { GameGlassUser }

export const useCurrentUser = () => {
  const { isSignedIn } = useAuth()

  return useQuery<GameGlassUser>({
    queryKey: [CURRENT_USER_QUERY_KEY, isSignedIn],
    queryFn: async () => (await getUserInfo()).data,
    // Clerk reports `undefined` while loading — only fetch once it confirms a session
    enabled: !!isSignedIn,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 5
  })
}